import type { WorkDateField, WorkItemEdit } from "@api/workItem.api";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";

type WorkDates = Pick<
    ClientsWorkOverviewWorkRow,
    "workStartDate" | "workDeliveryDate"
>;

/** The days a work date can move to: Work start stays on or before Work end. */
export const getWorkDateBounds = (
    { workStartDate, workDeliveryDate }: WorkDates,
    field: WorkDateField,
): { minDate?: string; maxDate?: string } =>
    field === "workStartDate"
        ? { maxDate: workDeliveryDate ?? undefined }
        : { minDate: workStartDate ?? undefined };

/**
 * The edit for a new work date, or null when it's unchanged or outside
 * `getWorkDateBounds`. Typed dates skip the calendar's disabled days, so
 * every save re-checks the bounds here.
 */
export const toWorkDateEdit = ({
    row,
    field,
    date,
}: {
    row: WorkDates;
    field: WorkDateField;
    date: string;
}): WorkItemEdit | null => {
    const { minDate, maxDate } = getWorkDateBounds(row, field);
    const isWithinBounds =
        (!minDate || date >= minDate) && (!maxDate || date <= maxDate);
    return date !== row[field] && isWithinBounds ? { field, date } : null;
};
